export default function Contatti() {
  return (
    <section id="contatti" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block border-2 border-orange-500 text-orange-500 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Contattaci
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            Siamo qui per aiutarti
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Contattaci per un preventivo gratuito, un&apos;installazione o qualsiasi domanda.
            Rispondiamo sempre entro 2 ore.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">

          {/* Info Cards */}
          <div className="w-full lg:w-1/2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-7">
              {[
                {
                  icon: 'ri-map-pin-2-fill',
                  title: 'Indirizzo',
                  lines: ['Largo Firenze', '48121 Ravenna (RA), Italia'],
                  link: null,
                },
                {
                  icon: 'ri-phone-fill',
                  title: 'Telefono',
                  lines: ['+39 380 632 8251'],
                  link: 'tel:+393806328251',
                },
                {
                  icon: 'ri-time-fill',
                  title: 'Orari',
                  lines: ['Aperto 24 ore su 24', '7 giorni su 7'],
                  link: null,
                },
                {
                  icon: 'ri-whatsapp-fill',
                  title: 'WhatsApp',
                  lines: ['+39 380 632 8251', 'Risposta rapida'],
                  link: 'https://wa.me/393806328251',
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="bg-[#F8F5F0] rounded-xl p-5 flex gap-4 items-start"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-orange-500 text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-1">
                      {item.title}
                    </p>
                    {item.lines.map((line) =>
                      item.link ? (
                        <a
                          key={line}
                          href={item.link}
                          target={item.link.startsWith('http') ? '_blank' : undefined}
                          rel={item.link.startsWith('http') ? 'nofollow noreferrer' : undefined}
                          className="block text-sm font-semibold text-orange-600 hover:text-orange-700 transition-colors cursor-pointer"
                        >
                          {line}
                        </a>
                      ) : (
                        <p key={line} className="text-sm font-semibold text-gray-800">
                          {line}
                        </p>
                      )
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Map */}
          <div className="w-full lg:w-1/2 rounded-2xl overflow-hidden h-72 md:h-96">
            <iframe
              title="Mappa Stufe a Pellet Ravenna - Largo Firenze"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2844.123456789!2d12.2019!3d44.4151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132cb53e0e1f1f1f%3A0x1234567890abcdef!2sLargo%20Firenze%2C%2048121%20Ravenna%20RA%2C%20Italy!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

        </div>
      </div>
    </section>
  );
}
